var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.state.modals.gradingModel)?_c('portal',{attrs:{"to":"modals"}},[_c('modal-component',{attrs:{"show":true,"container-classes":"max-w-content-xl my-12.5 md:my-0","wrapper-classes":"flex"},on:{"close":_vm.closeModal}},[_vm._t("default")],2)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }